// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Grid,
//   Button,
//   Typography,
// } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard from 'src/components/shared/DashboardCard';

// import { useMain } from '../hooks/useMain';
// import TextInputs from 'src/components/inputs/TextInputs';
// import { Box } from '@mui/system';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import ClinetSuggestion from './ClinetSuggestion';
// import { useLocation } from 'react-router';
// import RadioInputs from 'src/components/inputs/RadioInputs';

// const DiscountMembershipDetail = ({ data, allClinetsData }) => {
//   const [formData, setFormData] = useState({ clientNumber: '', membershipId: data._id, paymentType: '', clientName: '', gender: '' });
//   const [clientSuggested, setClientSuggested] = useState([]);
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [showNewClientFields, setShowNewClientFields] = useState(false);
//   const [clientExists, setClientExists] = useState(true);
//   const { buyMembership, activeBranchId, setShowMessage } = useMain();

//   const { state } = useLocation();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((pre) => ({ ...pre, [name]: value }));
//     if ((name === 'clientNumber' || name === 'clientName') && !showNewClientFields) {
//       updateSuggested(name, value);
//     }
//   };

//   const updateSuggested = (fieldName, inputValue) => {
//     const suggestions = allClinetsData.filter((product) =>
//       product[fieldName === 'clientName' ? 'clientName' : 'clientNumber']
//         ?.toLowerCase()
//         .includes(inputValue.toLowerCase())
//     );
//     setClientSuggested(suggestions);
//     setClientExists(suggestions.length > 0);
//   };

//   const handleSuggestedClick = (client) => {
//     setFormData((pre) => ({ ...pre, clientNumber: client.clientNumber }));
//     setClientSuggested([]);
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//     setFormData((pre) => ({ ...pre, clientNumber: '', membershipId: data._id, paymentType: '' }));
//     setClientSuggested([]);
//   };

//   const handleOpenDialogue = () => {
//     setOpenDialogue(true);
//   };

//   const handleBuyMembership = async () => {
//     const { clientNumber, paymentType } = formData;
//     if (clientNumber === '' || clientNumber.length !== 10)
//       return setShowMessage({
//         message: 'Client Number is required or invalid',
//         messageType: 'error',
//       });
//     if (paymentType === '')
//       return setShowMessage({
//         message: 'Payment Type is required',
//         messageType: 'error',
//       });
//     let requestBody = { clientNumber, membershipId: formData.membershipId, paymentType };
//     if (!clientExists) {
//       requestBody = { ...formData };
//     }

//     try {
//       setLoading(true);
//       const res = await buyMembership(activeBranchId, requestBody);
//       if (res.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'SuccessFully Bought Membership',
//           messageType: 'success',
//         });
//         setFormData({ clientNumber: '', membershipId: '', paymentType: '' });
//       } else {
//         setShowMessage({
//           message: res.message || 'Error Occurred while Buying Membership',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       handleCloseDialogue();
//       setLoading(false);
//     }
//   };


//   const handleAmountPaidInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };


//   useEffect(() => {
//     if (state) {
//       setFormData((pre) => ({ ...pre, clientNumber: state?.clientNumber }));
//     }
//   }, [state]);
//   // console.log(formData, "formDataa")
//   const handleAddNew = () => {
//     setShowNewClientFields(true);
//     setClientExists(false);
//     setFormData((prev) => ({ ...prev, clientName: '', gender: '' }));
//   };

//   return (
//     <PageContainer title="Membership Details" description="This is service type membership details">
//       <DashboardCard title="Membership Details">
//         <Grid container xs={12}>
//           <Grid container xs={8} spacing={4}>
//             <Grid item xs={12} display={'flex'} alignItems={'center'} spacing={3}>
//               <Grid item xs={6}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Membership Name: <strong>{data.membershipName}</strong>
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Membership Price: <strong>{data.membershipPrice}</strong>
//                 </Typography>
//               </Grid>
//             </Grid>
//             <Grid item xs={12} display={'flex'} alignItems={'center'} spacing={3}>
//               <Grid item xs={6}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Membership duration: <strong>{data.duration} month</strong>
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Reward Points: <strong>{data.rewardPointsOnPurchase}</strong>
//                 </Typography>
//               </Grid>
//             </Grid>
//             <Grid item xs={12} display={'flex'} alignItems={'center'} spacing={3}>
//               <Grid item xs={6}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Available Count: <strong>{data.discount.availableCount}</strong>
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Min Bill Amount: <strong>{data.discount.minBillAmount}</strong>
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Grid>

//           <Grid item xs={4}>
//             <button
//               style={{
//                 float: 'right',
//                 backgroundColor: '#6174DD',
//                 padding: '10px 15px',
//                 color: '#fff',
//                 borderRadius: '5px',
//                 fontSize: '14px',
//                 border: 'none',
//               }}
//               onClick={handleOpenDialogue}
//             >
//               Buy Membership
//             </button>
//           </Grid>

//           <Grid item xs={12}>
//             <table className="table-container mt-3">
//               <thead className="table-thead">
//                 <tr>
//                   {['Discount on Service', 'Discount on Products'].map(
//                     (h, index) => {
//                       return (
//                         <th key={index} style={{ width: '100%' }}>
//                           {h}
//                         </th>
//                       );
//                     },
//                   )}
//                 </tr>
//               </thead>
//               <tbody className="table-tbody">
//                 <tr>
//                   <td
//                     style={{ width: '100%' }}
//                   >{`${data?.discount?.discountOnService}   ${data?.discount?.serviceDiscountType}`}</td>
//                   <td
//                     style={{ width: '100%' }}
//                   >{`${data?.discount?.discountOnProduct}   ${data?.discount?.productDiscountType}`}</td>
//                   {/* <td
//                     style={{ width: '100%' }}
//                   >{`${data?.discount?.discountOnPackages}   ${data?.discount?.packageDiscountType}`}</td> */}
//                 </tr>
//               </tbody>
//             </table>
//           </Grid>
//         </Grid>
//         <Dialog
//           open={openDialogue}
//           onClose={handleCloseDialogue}
//           maxWidth="md"
//           sx={{
//             '& .MuiDialog-paper': {
//               width: '600px', // set the desired width
//               minHeight: '76vh', // set the desired max height (in this case, 80% of the viewport height)
//             },
//           }}
//         >
//           <DialogTitle>Buy Membership</DialogTitle>
//           <DialogContent>
//             <DialogContentText>Here you can Buy membership.</DialogContentText>
//             <DialogContentText>
//               <Grid item xs={6} style={{ padding: '1rem 0rem' }}>
//                 <Typography variant="body1" style={{ fontSize: '16px' }}>
//                   Membership Name: <strong>{data.membershipName}</strong>
//                 </Typography>
//               </Grid>
//             </DialogContentText>
//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={8}>
//                   <Box style={{ borderBottom: 'none' }}>
//                     <TextInputs
//                       title={'Client Number'}
//                       name={'clientNumber'}
//                       placeholder="client number"
//                       value={formData?.clientNumber}
//                       handleChange={handleChange}
//                       type={'text'}
//                     />
//                   </Box>
//                 </Grid>
//                 {!clientExists && !showNewClientFields && (
//                   <Grid item xs={4} style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
//                     <Button
//                       variant="contained"
//                       sx={{ backgroundColor: '#6174DD' }}
//                       onClick={handleAddNew}
//                     >
//                       Add New
//                     </Button>
//                   </Grid>
//                 )}
//                 <Grid item xs={12}>
//                   {clientExists && formData.clientNumber && ( // Only show suggestions if client exists and input is not empty
//                     <ClinetSuggestion
//                       data={clientSuggested}
//                       handleSuggestedClick={handleSuggestedClick}
//                     />
//                   )}
//                   {showNewClientFields && !clientExists && (
//                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                       <Box sx={{ width: '15rem' }}>
//                         <TextInputs
//                           title={'Client Name'}
//                           name={'clientName'}
//                           value={formData?.clientName}
//                           handleChange={handleChange}
//                           type={'text'}
//                         />
//                       </Box>
//                       <Box sx={{ width: '15rem' }}>
//                         <RadioInputs
//                           title={'Gender'}
//                           name={'gender'}
//                           value={formData?.gender}
//                           handleChange={handleChange}
//                           options={[
//                             { title: 'Male', value: 'Male' },
//                             { title: 'Female', value: 'Female' },
//                           ]}
//                         />
//                       </Box>
//                     </Box>
//                   )}
//                 </Grid>
//               </Grid>

//               <Grid container spacing={3}>
//                 <Grid item xs={6}>
//                   <Box sx={{ width: '15rem' }}>
//                     <Typography component="label"><strong>Payment Type</strong></Typography>
//                     <select

//                       className="form-select"
//                       aria-label="Default select example"
//                       data-validation="required"
//                       name="paymentType"
//                       value={formData.paymentType || ''}
//                       onChange={handleAmountPaidInputChange}
//                       style={{
//                         display: 'block',
//                         width: '100%',
//                         padding: '13px',
//                         fontSize: '16px',
//                         margin: '8px 0',
//                         borderRadius: '4px',
//                       }}
//                     >
//                       <option value="">
//                         --Select--
//                       </option>
//                       <option value="Cash">Cash</option>
//                       <option value="Credit/Debit Card">Credit/Debit card</option>
//                       <option value="Paytm">Paytm</option>
//                       <option value="PhonePe">PhonePe</option>
//                       <option value="Gpay">Gpay</option>
//                     </select>
//                   </Box>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <TextInputs
//                     title={'Amount Paid'}
//                     name={'amountPaid'}
//                     placeholder="amount paid"
//                     value={data?.membershipPrice}
//                     handleChange={handleAmountPaidInputChange}
//                     type={'text'}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>
//           </DialogContent>
//           <DialogActions>
//             <Button style={{ backgroundColor: 'red', color: 'white' }} onClick={handleCloseDialogue}>Cancel</Button>
//             <Button style={{ backgroundColor: '#6174DD', color: 'white' }} onClick={handleBuyMembership} disabled={loading}>
//               {loading ? 'Buying...' : 'Buy Membership'}
//             </Button>
//           </DialogActions>

//         </Dialog>
//         {loading && <ShowLoader />}
//       </DashboardCard>
//     </PageContainer >
//   );
// };

// export default DiscountMembershipDetail;

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Button,
  CircularProgress,
  Box,
  Divider
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import TextInputs from 'src/components/inputs/TextInputs';
import DashboardCard from 'src/components/shared/DashboardCard';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import ClinetSuggestion from './ClinetSuggestion';
import RadioInputs from 'src/components/inputs/RadioInputs';
import { useLocation } from 'react-router';
import { duration } from 'moment';
import { changeDateFormate } from 'src/utils/dateutils';

const DiscountMembershipDetail = ({ data, allClinetsData }) => {
  // State initialization
  const initialFormState = {
    clientNumber: '',
    membershipId: data._id,
    paymentType: '',
    clientName: '',
    gender: '',
    paidAmount: data?.membershipPrice,
    paidDues: 0
  };

  const [formData, setFormData] = useState(initialFormState);
  const [clientSuggested, setClientSuggested] = useState([]);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clientExists, setClientExists] = useState(true);
  const [showNewClientFields, setShowNewClientFields] = useState(false);
  
  const { buyMembership, activeBranchId, setShowMessage } = useMain();
  const { state } = useLocation();

  // Set client number from location state if available
  useEffect(() => {
    if (state?.clientNumber) {
      updateFormField('clientNumber', state.clientNumber);
    }
  }, [state]);

  // Helper function to update form fields
  const updateFormField = (name, value) => {
  setFormData(prev => {
    let updatedForm = { ...prev, [name]: value };

    // Cap the paidAmount to membershipPrice
    if (name === 'paidAmount') {
      let paid = Number(value) || 0;

      // If user tries to pay more than membershipPrice, cap it
      if (paid > data.membershipPrice) {
        paid = data.membershipPrice;
      }

      updatedForm.paidAmount = paid;
      updatedForm.paidDues = Math.max(0, data.membershipPrice - paid);
    }

    return updatedForm;
  });

  // Update client suggestions when client number changes
  if (name === 'clientNumber') {
    updateClientSuggestions(value);
  }
};


  // Update client suggestions based on input
  const updateClientSuggestions = (inputValue) => {
    const suggestions = allClinetsData.filter(client =>
      client.clientNumber?.toLowerCase().includes(inputValue.toLowerCase())
    );
    setClientSuggested(suggestions);
    setClientExists(suggestions.length > 0);
  };

  // Handle client selection from suggestions
  const handleSuggestedClick = (client) => {
    updateFormField('clientNumber', client.clientNumber);
    setClientSuggested([]);
  };

  // Dialog control functions
  const handleOpenDialogue = () => setOpenDialogue(true);
  const handleCloseDialogue = () => {
    setOpenDialogue(false);
    setShowNewClientFields(false);
    setClientExists(true);
    setFormData(initialFormState);
  };

  // Handle adding new client
  const handleAddNew = () => {
    setShowNewClientFields(true);
    setClientExists(false);
    updateFormField('clientName', '');
    updateFormField('gender', '');
  };

  // Handle membership purchase
  const handleBuyMembership = async () => {
    const { clientNumber, paymentType } = formData;
    
    // Validation
    if (!clientNumber || clientNumber.length !== 10) {
      return setShowMessage({
        message: 'Valid 10-digit client number is required',
        messageType: 'error',
      });
    }
    
    if (!paymentType) {
      return setShowMessage({
        message: 'Payment type is required',
        messageType: 'error',
      });
    }

    const requestBody = {
      ...formData,
      membershipId: data._id
    };

    try {
      setLoading(true);
      const res = await buyMembership(activeBranchId, requestBody);
      
      const message = res.statusCode === 200 
        ? res.message || "Membership purchased successfully"
        : res.message || "Error purchasing membership";
        
      setShowMessage({ 
        message, 
        messageType: res.statusCode === 200 ? 'success' : 'error' 
      });

      if (res.statusCode === 200) {
        handleCloseDialogue();
      }
    } catch (error) {
      setShowMessage({ 
        message: error.message || "Something went wrong", 
        messageType: 'error' 
      });
    } finally {
      setLoading(false);
    }
  };

  // Membership info display
  const renderMembershipInfo = () => (
    <Box sx={{ 
      p: 2, 
      mt: 2, 
      border: '1px solid #e0e0e0', 
      borderRadius: 1,
      bgcolor: '#fafafa'
    }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            Membership: <strong>{data.membershipName}</strong>
          </Typography>
          <Typography variant="subtitle1" sx={{ mt: 1 }}>
            Duration: <strong>{data.duration} months</strong>
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            Total Price: <strong>₹{data.membershipPrice}</strong>
          </Typography>
          <Typography variant="subtitle1" sx={{ mt: 1 }}>
            Dues: <strong>₹{formData.paidDues}</strong>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );

  // Payment details section
  const renderPaymentSection = () => (
    <>
      <Divider sx={{ my: 1 }} />
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Payment Details
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 600, color: 'black' }}>
              Payment Type *
            </Typography>
            <select
              className="form-select"
              name="paymentType"
              value={formData.paymentType || ''}
              onChange={(e) => updateFormField('paymentType', e.target.value)}
              style={{
                width: '100%',
                padding: '14px',
                marginTop: '0.8rem',
                fontSize: '14px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: '#fff',
              }}
            >
              <option value="">-- Select Payment Method --</option>
              <option value="Cash">Cash</option>
              <option value="Credit/Debit Card">Credit/Debit Card</option>
              <option value="Paytm">Paytm</option>
              <option value="PhonePe">PhonePe</option>
              <option value="Gpay">Google Pay</option>
            </select>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextInputs
            title="Amount Paid"
            name="paidAmount"
            placeholder="Enter amount paid"
            value={formData.paidAmount}
            handleChange={(e) => updateFormField('paidAmount', e.target.value)}
            type="number"
            fullWidth
            inputProps={{
              min: 0,
              max: data.membershipPrice
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Box sx={{
            p: 2,
            border: '1px solid #e0e0e0',
            borderRadius: 1,
            bgcolor: '#f5f5f5',
            display: 'flex',
            justifyContent: 'space-between'
          }}>
            <Typography variant="subtitle1">
              Amount Due:
            </Typography>
            <Typography variant="subtitle1" fontWeight="bold">
              ₹{formData.paidDues}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );

  return (
    <PageContainer title="Membership Details" description="This is discount type membership details">
      <DashboardCard title="Membership Details">
        <Grid container spacing={2}>
          {/* Membership Info Section */}
          <Grid item xs={8}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body1">
                  Membership Name: <strong>{data.membershipName}</strong>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  Price: <strong>₹{data.membershipPrice}</strong>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  Duration: <strong>{data.duration ? `${data?.duration} Months` : changeDateFormate(data?.validTill) }</strong>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  Reward Points: <strong>{data.rewardPointsOnPurchase}</strong>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  Available Count: <strong>{data.discount.availableCount ? data?.discount?.availableCount : 'Unlimited Count'}</strong>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  Min Bill Amount: <strong>{data.discount.minBillAmount}</strong>
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* <Grid item xs={4} sx={{ textAlign: 'right' }}>
            <Button
              variant="contained"
              onClick={handleOpenDialogue}
              sx={{
                backgroundColor: '#6174DD',
                '&:hover': { backgroundColor: '#4a5abb' }
              }}
            >
              Buy Membership
            </Button>
          </Grid> */}

          {/* Discount Table */}
          <Grid item xs={12}>
            <table className="table-container mt-3">
              <thead className="table-thead">
                <tr>
                  {['Discount on Service', 'Discount on Products'].map((h, index) => (
                    <th key={index}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="table-tbody">
                <tr>
                  <td>{`${data?.discount?.discountOnService} ${data?.discount?.serviceDiscountType}`}</td>
                  <td>{`${data?.discount?.discountOnProduct} ${data?.discount?.productDiscountType}`}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
        </Grid>

        {/* Purchase Dialog */}
        <Dialog
          open={openDialogue}
          onClose={handleCloseDialogue}
          maxWidth="sm"
          fullWidth
          sx={{
            '& .MuiDialog-paper': {
              width: '500px',
              minHeight: '76vh',
            },
          }}
        >
          <DialogTitle sx={{ fontSize: '1.5rem', fontWeight: 600, bgcolor: '#f5f5f5' }}>
            Buy Membership
          </DialogTitle>

          <DialogContent sx={{ py: 3 }}>
            <Typography variant="body1" color="text.secondary">
              Complete the following details to purchase membership
            </Typography>

            {renderMembershipInfo()}

            <Grid container spacing={3}>
              {/* Client Number Section */}
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2 }}>
                  <Box sx={{ flex: 1 }}>
                    <TextInputs
                      title="Client Number"
                      name="clientNumber"
                      placeholder="Enter client number"
                      value={formData.clientNumber}
                      handleChange={(e) => updateFormField('clientNumber', e.target.value)}
                      type="text"
                      fullWidth
                    />
                  </Box>

                  {!clientExists && !showNewClientFields && (
                    <Button
                      variant="contained"
                      onClick={handleAddNew}
                      sx={{
                        backgroundColor: '#6174DD',
                        height: '46px',
                        mb: '8px'
                      }}
                    >
                      Add New
                    </Button>
                  )}
                </Box>

                {clientExists && formData.clientNumber && (
                  <ClinetSuggestion
                    data={clientSuggested}
                    handleSuggestedClick={handleSuggestedClick}
                  />
                )}
              </Grid>

              {/* New Client Fields */}
              {showNewClientFields && !clientExists && (
                <Grid item xs={12}>
                  <Box sx={{
                    p: 2,
                    border: '1px solid #e0e0e0',
                    borderRadius: 1,
                    bgcolor: '#fafafa'
                  }}>
                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                      New Client Details
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <TextInputs
                          title="Client Name"
                          name="clientName"
                          placeholder="Enter client name"
                          value={formData.clientName}
                          handleChange={(e) => updateFormField('clientName', e.target.value)}
                          type="text"
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <RadioInputs
                          title="Gender"
                          name="gender"
                          value={formData.gender}
                          handleChange={(e) => updateFormField('gender', e.target.value)}
                          options={[
                            { title: 'Male', value: 'Male' },
                            { title: 'Female', value: 'Female' },
                          ]}
                          row
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              )}

              {/* Payment Section */}
              <Grid item xs={12}>
                {renderPaymentSection()}
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0' }}>
            <Button
              variant="outlined"
              onClick={handleCloseDialogue}
              sx={{
                color: '#f44336',
                borderColor: '#f44336',
                '&:hover': {
                  borderColor: '#d32f2f',
                  backgroundColor: 'rgba(244, 67, 54, 0.04)'
                }
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleBuyMembership}
              disabled={loading}
              sx={{
                backgroundColor: '#6174DD',
                '&:hover': { backgroundColor: '#4a5abb' }
              }}
            >
              {loading ? (
                <>
                  <CircularProgress size={20} sx={{ color: 'white', mr: 1 }} />
                  Processing...
                </>
              ) : 'Confirm Purchase'}
            </Button>
          </DialogActions>
        </Dialog>

        {loading && <ShowLoader />}
      </DashboardCard>
    </PageContainer>
  );
};

export default DiscountMembershipDetail;